import { useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import DeviceTableService from '../service/DeviceTableService';
import ClientRegistryStatusTableCell from '../component/ClientRegistryStatusTableCell';
import DeviceEditService from '../service/DeviceEditService';
import DeviceService from '../service/DeviceService';
import DeviceIsOnlineTableCell from '../component/DeviceIsOnlineTableCell';
import StreamingStartButton from '../component/StreamingStartButton';
import TimeAgoTableCell from '../component/TimeAgoTableCell';
// import DeviceStopButton from '../component/DeviceStopButton';

const config = data => {
	return {
		key: 'deviceTable',
		text: 'Device',
		textKey: 'deviceTable',
		service: DeviceTableService,
		editFormState: item => `/device/edit/${item ? item.id : 'new'}`,
		toolbarAction: data.user.isSuperAdmin ? ['filter', 'search', 'refresh'] : ['search', 'refresh'],
		rowAction: ['modify', 'delete'],
		filterFields: [
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			}
		],
		rowButtonList: [
			{
				key: 'start',
				component: StreamingStartButton
			},
			// {
			// 	key: 'stop',
			// 	component: DeviceStopButton
			// }
		],
		rowEndButtonList: [
			{
				key: 'registryStatus',
				component: ClientRegistryStatusTableCell,
				service: DeviceService
			}
		],
		columns: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			// {
			// 	key: 'externalName',
			// 	text: 'External Name',
			// 	textKey: 'externalName',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'model',
			// 	text: 'Model',
			// 	textKey: 'model',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'version',
			// 	text: 'Version',
			// 	textKey: 'version',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			{
				key: 'project.name',
				text: 'Project',
				textKey: 'project.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'location',
				text: 'Location',
				textKey: 'location',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'deviceType.name',
				text: 'Device Type',
				textKey: 'deviceType.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'status',
				text: 'Status',
				textKey: 'status',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'lastSeen',
				text: 'Last Seen',
				textKey: 'lastSeen',
				// type: 'date',
				sortable: false,
				disablePadding: false,
				component: TimeAgoTableCell,
			},
			{
				key: 'registryStatus',
				text: 'Registry Status',
				textKey: 'registryStatus',
				type: 'text',
				sortable: true,
				disablePadding: false
			}
			// {
			// 	key: 'project.name',
			// 	text: 'Project',
			// 	textKey: 'project.name',
			// 	type: 'text',
			// 	sortable: true,
			// 	visibleIf: () => data.user.isSuperAdmin,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'infrastructureElement.name',
			// 	text: 'Infrastructure Element',
			// 	textKey: 'infrastructureElement.name',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'location.name',
			// 	text: 'Infrastructure Location',
			// 	textKey: 'location.name',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'classificationAlgorithmStatus',
			// 	text: 'AI output',
			// 	textKey: 'classificationAlgorithmStatus',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'isOnline',
			// 	text: 'is Online?',
			// 	component: DeviceIsOnlineTableCell,
			// 	sortable: false,
			// 	disablePadding: false
			// }
		]
	};
};

function DeviceTable() {
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });

	return <TableBrowser config={myConfig} />;
}

export default withReducer('deviceTable', reducer('deviceTable'))(DeviceTable);
